// App.js (excerpt)
import React, { useState } from 'react';
import Header from './Header';
import { Container, Box } from '@mui/material';
import Calculator from './Calculator';
import FragmentsCalculator from './FragmentsCalculator';
import './App.css';

function App() {
  const [fragments, setFragments] = useState(false);
  const [language, setLanguage] = useState('en');

  return (
    <div className="App">
      <Header
        fragments={fragments}
        setFragments={setFragments}
        language={language}
        setLanguage={setLanguage}
      />
      <Container>
        {!fragments && (<Box sx={{ mt: 4 }}>
          <Calculator />
        </Box>
        )}
        {fragments && (<Box sx={{ mt: 4 }}>
          <FragmentsCalculator />
        </Box>
        )}
      </Container>
      <Container>
        This app is currently in development, multi-language and multi-account version support is coming next
      </Container>
    </div>
  );
}

export default App;
